import React from "react";
import Colors from "../config/Colors";
import Powered from "./Powered";
import AgioIcon from "../assets/LegendsLeagueLogo.svg";
import CustomText from "./CustomText";
import Currency from "../config/Currency";
import { isMobile } from "../types/type";

interface FirstTimeProps {
  amount?: number | string;
  onPlayNow?: () => void;
}

function FirstTime({ amount, onPlayNow }: FirstTimeProps) {
  const handlePlay = () => {
    if (onPlayNow) {
      onPlayNow();
    }
  };

  return (
    <div className="otherFirstTimeContainer">
      <div className="otherFirstTimeContentContainer">
        <img src={AgioIcon} alt="" className="otherFirstTimeAjioIcon" />
        <CustomText
          spacing={5}
          size="mediumLarge"
          style={{ maxWidth: "80%", alignItems: "center", textAlign: "center" }}
          color={Colors.blueGray}
        >
          AJIO LEGENDS LEAGUE
        </CustomText>
        <CustomText
          size="medium"
          color={Colors.blueGray}
          marginTop={isMobile ? "15%" : "3%"}
          marginBottom={isMobile ? "5%" : 30}
        >
          Register to Make Your Picks
        </CustomText>
        <div className="otherFirstTimePlayNowButton" onClick={handlePlay}>
          <CustomText weight="700" size="medium" color={Colors.primary}>
            PLAY NOW
          </CustomText>
        </div>
        <CustomText
          weight="900"
          size={isMobile ? "xxlarge" : "prize"}
          className="textMatchPrizeTextWeeklyPrize"
        >
          {Currency.rupee}
          {amount}
        </CustomText>
        <div className="containerMatchHeaderDropdownWeelyPrizesBottom">
          <CustomText
            size={isMobile ? "smallMedium" : "mediumLarge"}
            weight="500"
            marginBottom={10}
            className="textMatchPrizeTextWeeklyPrize"
          >
            Total Prizes
          </CustomText>
        </div>
      </div>
      <Powered color={Colors.blueGray} />
    </div>
  );
}

export default FirstTime;
